import React from 'react';
import { useParams, Navigate } from 'react-router-dom';

interface WorkspaceRedirectProps {
  path: string;
}

export function WorkspaceRedirect({ path }: WorkspaceRedirectProps) {
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const redirectTo = `/w/${workspaceId}/dashboard/${path}`;
  return <Navigate to={redirectTo} replace />;
}